import { render, staticRenderFns } from "./order_pj.vue?vue&type=template&id=47940a8b&scoped=true"
import script from "./order_pj.vue?vue&type=script&lang=js"
export * from "./order_pj.vue?vue&type=script&lang=js"
import style0 from "./order_pj.vue?vue&type=style&index=0&id=47940a8b&prod&scoped=true&lang=less"
import style1 from "./order_pj.vue?vue&type=style&index=1&id=47940a8b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47940a8b",
  null
  
)

export default component.exports